import DocumentPage from './DocumentPage';

export default DocumentPage;
